import * as Sentry from '@sentry/react';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { Error as DefaultErrorPage } from 'react-admin';

// React Admin's layout catches errors in rendering a page and shows this page
// instead, so they never reach Sentry on their own. Each one is reported here.
const ErrorPage = ({ error, errorInfo, ...props }) => {
  useEffect(() => {
    Sentry.captureReactException(error, errorInfo || {});
  }, [error, errorInfo]);

  return (
    <DefaultErrorPage
      error={error}
      errorInfo={errorInfo}
      {...props}
    />
  );
};

ErrorPage.propTypes = {
  error: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  errorInfo: PropTypes.object,
};

export default ErrorPage;
